module.exports = __webpack_public_path__ + "img/2025-05-09a_9.f9a30493.jpg";